import { useSuspenseQuery } from '@apollo/client/react';

import { AppProductTypeEnum, AppProtectionStatusEnum } from 'src/graphql/schema';
import { AppProtectionsDocument } from 'src/graphql/actions/apps/appProtections.query';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';
import { withSuspense } from 'src/hoc';
import { Skeleton } from '@/components/ui/skeleton';

const PRODUCT_TYPE_ORDER = Object.keys(productTypeMap) as AppProductTypeEnum[];

const ActiveProtectionsSkeleton = () => (
  <Skeleton data-testid="active-protections-skeleton" className="h-6 w-14 shrink-0" />
);

type Props = {
  appId: string;
};

const ActiveProtections = ({ appId }: Props) => {
  const {
    data: { appProtections },
  } = useSuspenseQuery(AppProtectionsDocument, {
    variables: { appId, statuses: [AppProtectionStatusEnum.Active] },
    fetchPolicy: 'cache-and-network',
  });

  const activeProductTypes = new Set(appProtections.map(({ productType }) => productType));
  const productTypes = PRODUCT_TYPE_ORDER.filter((productType) => activeProductTypes.has(productType));

  if (!productTypes.length) return null;

  return (
    <ul aria-label="Active protections" className="flex shrink-0 items-center gap-1">
      {productTypes.map((productType) => {
        const { icon: Icon, label } = productTypeMap[productType];

        return (
          <li key={productType}>
            <span role="img" aria-label={label} className="block">
              <Icon className="size-6" />
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default withSuspense(ActiveProtections, ActiveProtectionsSkeleton);
